import React, { useState } from 'react';

const ProductQuantityInput = () => {
  const [count, setCount] = useState(1);

  const handleDecrease = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handleIncrease = () => {
    setCount(count + 1);
  };

  return (
    <div  className='d-flex align-items-center'>
      <button onClick={handleDecrease} className='pi-minus-btn'>-</button>
      <input
        type="text"
        value={count}
        className='form-control pi-quantity'
        onChange={(e) => {
          const val = parseInt(e.target.value, 10);
          setCount(val > 0 ? val : 1);
        }}
        min="1"
      />
      <button onClick={handleIncrease} className='pi-plus-btn'>+</button>
    </div>
  );
};

export default ProductQuantityInput;
